// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e48e715","453":"9113cdd5","455":"58cf89ed","977":"541a1de9"}[chunkId] + ".chunk.js";
};